import gql from 'graphql-tag'

export const SEND_REVIEW = gql`
  mutation send_review(
    $name: String!
    $email: String
    $phone: String
    $comment: String!
    $grade: Int!
    $productId: String
    $token: String!
    $photos: [Upload]
    $videos: [Upload]
  ) {
    sendReview(
      name: $name
      email: $email
      phone: $phone
      comment: $comment
      grade: $grade
      productId: $productId
      token: $token
      photos: $photos
      videos: $videos
    )
  }
`
